// Two version numbers govern two different layers:
//
//   IDB_VERSION             -> shape of the IndexedDB container (stores + indexes).
//                              Triggers `onupgradeneeded` on bump. Bump ONLY when
//                              changing object stores / indexes.
//   CURRENT_SCHEMA_VERSION  -> shape of the Y.Doc payload inside each session.
//                              Bump when the live client's doc structure changes incompatibly.
//                              Mismatch is handled per-session (discard on hydrate); no IDB-level
//                              migration needed. 2 = CRDT schema v2 (`doc["t"]` + sidecars).
export const DB_NAME = 'transcription-ui:doc-cache'
export const IDB_VERSION = 1

export const CHUNKS_STORE = 'chunks'
export const SESSIONS_STORE = 'sessions'
// Non-unique index on `sessions.lastWrittenAt` so LRU eviction can walk
// oldest-first via cursor.
export const LAST_WRITTEN_AT_INDEX = 'lastWrittenAt'

export const CURRENT_SCHEMA_VERSION = 2

// Cap on persisted sessions. Writes beyond the cap evict the oldest by
// `sessions.lastWrittenAt`, range-deleting all chunks for that session.
export const MAX_CACHED_SESSIONS = 10

// Trailing throttle for `Y.Doc.on('update', ...)` writes; bursts coalesce into
// one appended chunk per window.
export const WRITE_THROTTLE_MS = 5000

// Cap on the IDB-await phase of `hydrate()` (open + getSession + getChunks +
// any cleanup deleteSession). On hang we fall through to a fresh-sync boot
// rather than block startup; this is where the pathological slowdowns happen
// (locked DB across tabs, slow disks, quota exhaustion, blocked-on-upgrade).
//
// NOT a hard cap on hydrate's wall-clock time: once all chunks are in memory,
// `mergeUpdatesChunked` + `Y.applyUpdate` runs synchronously and cannot be
// preempted. Merge cost is bounded by `COMPACT_FORCE_THRESHOLD_BYTES`
// instead; a true wall-clock cap would require running the merge on a Worker.
export const HYDRATE_IDB_TIMEOUT_MS = 1500

// Forces compaction on the next throttle tick, even mid-session. Bounds the
// worst-case main-thread freeze from `Y.mergeUpdates` on flush.
export const COMPACT_FORCE_THRESHOLD_BYTES = 1_024_000

// Compaction at moments the user can't perceive a freeze:
// `destroy()` and `visibilitychange === 'hidden'`.
// Lower than the force threshold so the cache trends toward a single
// compacted chunk during natural lulls.
export const COMPACT_OPPORTUNISTIC_THRESHOLD_BYTES = 128_000
